import React, { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";

const placeholderImage =
  "https://static.vecteezy.com/system/resources/thumbnails/004/141/669/small/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg";

const ModalPhotosOrder = ({
  isOpenPhotosOrder,
  selectedNegotiationPhotosOrder,
  modePhotosOrder,
  photosPhotosOrder,
  showSuccessScreenPhotosOrder,
  closePhotosOrderModal,
  handlePhotoChange,
  handleSubmit,
  loadingPhotosOrder,
  errorPhotosOrder,
  successPhotosOrder,
}) => {
  const isUploadMode = modePhotosOrder === "upload";
  const isConfirmMode = modePhotosOrder === "confirm";
  const uploadLocked = Boolean(selectedNegotiationPhotosOrder?.photos_locked);

  useEffect(() => {
    if (isOpenPhotosOrder) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    };
  }, [isOpenPhotosOrder]);

  if (!isOpenPhotosOrder) return null;

  return (
    <div
      className="modal-overlay"
      onClick={closePhotosOrderModal}
      style={{
        alignItems: "flex-start",
        overflowY: "auto",
        padding: "20px 12px",
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          height: "auto",
          maxHeight: "none",
          maxWidth: "520px",
          margin: "auto",
        }}
      >
        <div className="modal-header">
          <h2>
            {isUploadMode && !uploadLocked
              ? "Inserir fotografias"
              : isUploadMode && uploadLocked
                ? "Verificar fotografias"
                : "Confirmar fotografias"}
          </h2>
        </div>

        <div className="modal-body">
          {showSuccessScreenPhotosOrder ? (
            <div className="receiver-success-container">
              <CheckCircle2 size={90} className="receiver-success-icon" />
              <h3 style={{ marginBottom: -5 }}>Ação realizada com sucesso</h3>
              <p>{successPhotosOrder}</p>
              <button
                onClick={closePhotosOrderModal}
                className="action-btn ghost"
              >
                Entendi
              </button>
            </div>
          ) : (
            <>
              {selectedNegotiationPhotosOrder?.trip && (
                <p style={{ marginBottom: 12 }}>
                  <strong>Viagem:</strong>{" "}
                  {selectedNegotiationPhotosOrder.trip?.cidade_origem ||
                    selectedNegotiationPhotosOrder.trip?.de}{" "}
                  →{" "}
                  {selectedNegotiationPhotosOrder.trip?.cidade_destino ||
                    selectedNegotiationPhotosOrder.trip?.para}
                </p>
              )}

              <div className="photos-grid">
                {photosPhotosOrder.map((item, index) => (
                  <div className="photo-slot" key={index}>
                    <img
                      src={item.preview || placeholderImage}
                      alt={`foto-${index + 1}`}
                      className="photo-preview"
                    />

                    {isUploadMode && !uploadLocked && (
                      <label className="photo-upload-label">
                        Upload
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) =>
                            handlePhotoChange(index, e.target.files?.[0])
                          }
                        />
                      </label>
                    )}
                  </div>
                ))}
              </div>

              {isConfirmMode && (
                <div className="modal-info-block">
                  Confirmo que tenho ciência do conteúdo que estou levando e
                  tive a oportunidade de abrir e analisar a encomenda antes de
                  aceitar levar.
                </div>
              )}

              {/*{uploadLocked && isUploadMode && (
                <div className="modal-info-block">
                  Fotografias já cadastradas para esta negociação.
                </div>
              )}*/}

              {errorPhotosOrder && (
                <div className="modal-error">{errorPhotosOrder}</div>
              )}

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={closePhotosOrderModal}
                  disabled={loadingPhotosOrder}
                >
                  Cancelar
                </button>

                {isUploadMode && !uploadLocked && (
                  <button
                    type="button"
                    className="action-btn save-modal"
                    onClick={handleSubmit}
                    disabled={loadingPhotosOrder}
                  >
                    {loadingPhotosOrder ? "Enviando..." : "Inserir"}
                  </button>
                )}

                {isConfirmMode && (
                  <button
                    type="button"
                    className="action-btn save-modal"
                    onClick={handleSubmit}
                    disabled={loadingPhotosOrder}
                  >
                    {loadingPhotosOrder
                      ? "Processando..."
                      : "Confirmar fotografias"}
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalPhotosOrder;
